"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jobNames = void 0;
var jobNames;
(function (jobNames) {
    jobNames["GEMCO"] = "gemcoKitDelivery";
    jobNames["PRECISION"] = "precisionKitDelivery";
    jobNames["PCI_EMAIL"] = "pciEmailSending";
    jobNames["PCI_LETTER"] = "pciLetterSending";
    jobNames["SEND_SMS_US"] = "smsSendingUs";
    jobNames["SEND_SMS_UK"] = "smsSendingUk";
    jobNames["SEND_PUSH_NOTIFICATION_US"] = "sendPushNotificationUs";
    jobNames["SEND_PUSH_NOTIFICATION_UK"] = "sendPushNotificationUk";
})(jobNames || (exports.jobNames = jobNames = {}));
